module.exports = __webpack_public_path__ + "img/winnings-weekly.7d580bd9.png";